import React from 'react'

export interface DurationButtonProps {
    duration: number;
    isSelected?: boolean;
    isDisabled?: boolean;
    onClick: () => void;
}

export function DurationButton({ duration, isSelected, isDisabled, onClick }: DurationButtonProps) {
    const classNames = 'min-h-10 md:min-w-[82px] rounded-full px-4 flex items-center justify-center whitespace-nowrap h-full'
    if (isDisabled) {
        return (
            <div className={`${classNames} border border-neutral-200 bg-[#f9f9f9]`}>
                <span className="text-neutral-500 text-sm">{duration} min</span>
            </div>
        )
    }

    if (isSelected) {
        return (
            <div className={`${classNames} bg-black text-white cursor-pointer`}>
                <span className="text-sm">{duration} min</span>
            </div>
        )
    }

    return (
        <button
            onClick={onClick}
            className={`${classNames} cursor-pointer bg-white border border-black`}
        >
            <span className="text-black text-sm">{duration} min</span>
        </button>
    )
}
